import {
  constructionAsset,
  constructionSafety,
  logisticsAsset,
  logisticsSafety,
  manufacturingAsset,
} from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';

export default {
  desc: 'Quản lý logistics và hàng tồn kho là một trong những yếu tố cốt lõi trong môi trường kinh doanh hiện đại. Trung tâm logistics đóng vai trò then chốt trong việc quản lý hiệu quả quy trình sản xuất và bán hàng, và hiệu quả đó liên quan trực tiếp đến sự thành công của doanh nghiệp.',
  keywords:
    'Kho hàng logistics, quản lý kho, quản lý kho hàng trung tâm logistics, RTLS, kho hang logistics, quan ly kho, quan ly kho hang trung tam logistics, RTLS.',
  ogSite: 'Hiện đại hóa quản lý kho hàng tại trung tâm logistics: Giải pháp dựa trên RTLS',
  title: 'Hiện đại hóa quản lý kho hàng tại trung tâm logistics: Giải pháp dựa trên RTLS',
  ogUrl: 'https://orbro.io/vi/blog/logisticsAsset',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AKsag4POsGyW8_6UaAHXbyNzVpk_9ryErunfmUV3yK3f4WmvwJkZnca4uxHbMjmgtlBtU0eyUNtbcUO-7wWCY_NtuoV_D1SNBJD5pUHVTtoGqonJUgcV5H8yfvd2A-hQO4IVx6J1DyDHLtNqYbspd44GBG-yAQwFvQlLNDdW8wU-mA3M9nPJFhcC9T9aR6PgH3sfGEXLve_5lvKF5XfXDYhLprnf8H1LzwLiix2kgKA00_RTCK1bbaRJEzBh0k5nHNZ9A5nJ9BpKRw10eXYPbfzK77pY2JI_lu6ERZzceBmKgpycXSZr8VZr3kaXFkFq2gqb1IM3hj3qvIDUKszW0O3rmfXXRSBMe7vpCm9KtllBv6KIRJDxeP2k6DydbeOk6uZV--YQJevEDWeWjZtGbsyILS8c9MKtSGO5L0-YOBkYKY1GQJ8vypXh-eB6n4vVr9TqBQ2xLF5XnjbOvUchPCmvGANVC3ZIZbnAB6d9OHed1xvW4hFVEoXBfEbtU2vhm9H_APEtD754ywgCvzhpWfpeJ6eLTAQ7E0uIWdbAf5PO3724DMSARXYPKPJzu4GxlXnD7E5QyttqRcPxZe-nrOW2YOsoXfwetLvak8QSFcdP42YEdih_wYjISf43d1x5dqWCSOlgWRPLXopdeX6rOole8ZBTHy4vv0TxkDZKWaVy-7hzo73uazr9ZUY7Dg_MB7qOAkEof0_f8GYhBYNABTj76pFmcJf12m4bsEas8IcfrDLDnyaWnLprNFIktVeN5TThyXlGFDWlvYGtmwmpcKGe-MzLPASU4qspqg1wvasKCdODklzCeBaYWuUFGr2BsbSKf_WLxOPDQjofRp-YFwef83luUrcqyUrmv6_v_Ylv8eUnKGFLTUF6OAv9Bvu6z5NfThURg-F961Zq9ldOh6i-2icRVd4IbqzpQrmrkhKXDfyJSF6zGOqeWEL20TZ4aufvWDxI89w4fEch-aweyAlwgG5ti5Sph300hnuWbdoGWZALDTySeEPgnEsbXTK5ZY-xHWc_lCAmHWxJYpL8h5AHcJGLyM8-i8oKQJkfn46SIDh-NvCB6G1BOtaRqc-GioWlIoo-l5EEyMwQnCVZ_Y_4RSlwtoYlk-zmIAAaMQns5mV5NH1xoiOjQLfKBs504gW8hxqKJEXtNhbeKOSh8iWrrjST3gRVpqlRvLAhFhtdDl3UoWc1mXW4MyYCci_UVC2vXGoaQS9-LAK47__t29nN2CyayOnGXejrN_ZFm68lwCjdlehA_CHMn7-VHo-T3yEr2rQbtt44dEBwZ25mEprNmtwak6dCDB1VyU1RYyoKX1TShaZguXXbnSTTwgIRKPZWD1fdToLBGf8uoYWuF60W42K2m55DZyJLHd4UCgwTP-OqDqxNAyD-SwaTzeHSCjHEctiAo5VvypNZj0K1YX32n0Tz951ly0vRFchzoSkIGMjs4lAvmA3DSXNDsCof-3ZfB-UZKY7xZybELiWtYxoS-cG233aezqbt9-yQNxvH5IfsOZxPoGTYO0nB2VOmHGMlPRcryGTIN1fTA8dBby0gz4w=w2000-h1992',
  ogType: 'website',
  date: '2023-09-08',
  tag1: '#Khohanglogistics',
  tag2: '#Quanlykho',
  tag3: '#Quanlykhohangtrungtamlogistics',
  tag4: '#RTLS',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Quản lý logistics và hàng tồn kho là một trong những yếu tố cốt lõi trong môi trường kinh doanh hiện đại. Trung tâm logistics đóng vai trò then chốt trong việc quản lý hiệu quả quy trình sản xuất và bán hàng, và hiệu quả đó liên quan trực tiếp đến sự thành công của doanh nghiệp. Một phương pháp để cách mạng hóa việc quản lý hàng tồn kho tại trung tâm logistics bằng cách sử dụng công nghệ và giải pháp mới nhất là áp dụng các giải pháp dựa trên RTLS (Real-Time Location System). Trong bài viết này, chúng ta sẽ xem xét cách RTLS có thể hiện đại hóa việc quản lý hàng tồn kho của trung tâm logistics.',
      dot: '',
    },
    {
      head: 'Giới thiệu về RTLS',
      subHead: '',
      desc: 'RTLS là công nghệ theo dõi vị trí thời gian thực của vật thể hoặc đối tượng, giúp xác định chính xác vị trí của nhiều loại tài sản khác nhau trong trung tâm logistics như hàng tồn kho, thiết bị, công nhân và phương tiện vận chuyển. Hệ thống RTLS chủ yếu sử dụng các công nghệ đa dạng như RFID (Nhận dạng qua tần số vô tuyến), UWB (Băng thông siêu rộng), Wi-Fi, Bluetooth và GPS để thu thập và phân tích dữ liệu vị trí.',
      dot: '',
    },
    {
      head: 'RTLS cách mạng hóa quản lý kho hàng',
      subHead: 'Theo dõi hàng tồn kho theo thời gian thực',
      desc: 'RTLS cho phép xác định vị trí theo thời gian thực của tất cả các mặt hàng tồn kho. Điều này giúp theo dõi và dự đoán sự di chuyển cũng như thay đổi của hàng tồn kho theo thời gian thực.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý kho tự động',
      desc: 'Hệ thống RTLS có thể tự động theo dõi và quản lý số lượng hàng tồn kho. Có thể phòng ngừa trước các vấn đề như thiếu hàng hoặc mua dư thừa, đồng thời cắt giảm chi phí.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Nâng cao dịch vụ khách hàng',
      desc: 'Sử dụng RTLS để tối ưu hóa quy trình đặt hàng và giao hàng, rút ngắn thời gian xử lý đơn hàng và nâng cao độ chính xác. Nhờ đó, chất lượng dịch vụ khách hàng được cải thiện.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tính linh hoạt và khả năng mở rộng',
      desc: 'Hệ thống RTLS có thể dễ dàng mở rộng tùy theo quy mô hoặc cấu trúc của trung tâm logistics. Có thể điều chỉnh hệ thống bằng cách lắp đặt thêm cảm biến hoặc thông qua cập nhật phần mềm (software update) khi cần thiết.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Phân tích và dự đoán',
      desc: 'Dữ liệu RTLS cung cấp những hiểu biết giá trị về hàng tồn kho và hoạt động logistics. Thông qua phân tích dữ liệu, có thể tối ưu hóa quy trình logistics và dự đoán các xu hướng trong tương lai.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tăng cường an toàn và an ninh',
      desc: 'RTLS cũng giúp tăng cường an toàn và an ninh trong trung tâm logistics. Bằng cách xác định vị trí thiết bị và hàng tồn kho theo thời gian thực, có thể phòng ngừa hoặc ứng phó với tai nạn hoặc trộm cắp.',
      dot: '',
    },
    {
      head: 'Các trường hợp thành công',
      subHead: '',
      desc: 'Các doanh nghiệp đã áp dụng RTLS đang cải thiện đáng kể hiệu suất và hiệu quả logistics. Các trung tâm logistics quy mô lớn như Amazon sử dụng RTLS để rút ngắn thời gian xử lý đơn hàng, tăng độ chính xác của hàng tồn kho và nâng cao sự hài lòng tổng thể của khách hàng. Ngoài ra, các cơ sở y tế sử dụng RTLS để theo dõi thiết bị y tế và bệnh nhân, đồng thời cải thiện sự an toàn.',
      dot: '',
    },
    {
      head: 'Kết luận',
      subHead: '',
      desc: 'Việc hiện đại hóa quản lý hàng tồn kho tại trung tâm logistics là một bước thiết yếu để duy trì năng lực cạnh tranh và tăng trưởng trong kinh doanh hiện đại. Các giải pháp dựa trên RTLS là công cụ mạnh mẽ giúp tối ưu hóa quy trình logistics và nâng cao hiệu quả của trung tâm logistics thông qua dữ liệu vị trí thời gian thực. Bằng cách áp dụng RTLS, doanh nghiệp có thể cắt giảm chi phí, nâng cao chất lượng dịch vụ khách hàng và thực hiện quản lý logistics thông minh (smart) và hiệu quả hơn. Do đó, các doanh nghiệp muốn mang lại sự đổi mới cho hoạt động của trung tâm logistics cần chú ý đến công nghệ RTLS.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.ble.bleStarterKit.title,
        title: productPurchase.purchase.ble.bleStarterKit.title,
        serial: productPurchase.purchase.ble.bleStarterKit.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.bleStarterKit.key1,
      },
      {},
    ],
    solution: [
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
      {
        img: logisticsSafety.thumb,
        data: 'logisticsSafety',
        link: '/vi/enterprise/logistics/safety',
      },
      {
        img: manufacturingAsset.thumb,
        data: 'manufacturingAsset',
        link: '/vi/enterprise/manufacturing/asset',
      },
    ],
  },
};
